// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hr-right[data-v-70b8fc88] {\n  border-right: solid 1px gray;\n}\n", ""]);
// Exports
module.exports = exports;
